export default "__VITE_ASSET__a5e26db6__"